import React, { useState, useRef, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import {
  styles,
  getListMultiProofScrollStyles,
} from "../components/LoginStyles";

export const LicenseProofCell = ({ values = [] }) => {
  const [isScrollEnabled, setScrollEnabled] = useState(false);
  const containerRef = useRef(null);

  const licenseProofs = Array.isArray(values)
    ? values.filter((file) => file)
    : values
    ? [values]
    : [];

  const handleClick = () => {
    if (licenseProofs.length > 1 && !isScrollEnabled) {
      setScrollEnabled(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setScrollEnabled(false);
      }
    };

    if (isScrollEnabled) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isScrollEnabled]);

  const handleDownload = (fileUrl, index) => {
    const isPDF = fileUrl.toLowerCase().endsWith(".pdf");
    const isBase64 = fileUrl.startsWith("data:");

    if (isBase64) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = isPDF
        ? `License_Proof_${index + 1}.pdf`
        : `License_Proof_${index + 1}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = isPDF
            ? `License_Proof_${index + 1}.pdf`
            : `License_Proof_${index + 1}.jpg`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Download failed:", error);
          window.open(fileUrl, "_blank");
        });
    }
  };

  return (
    <div
      ref={containerRef}
      style={getListMultiProofScrollStyles(isScrollEnabled, licenseProofs)}
      onClick={handleClick}
    >
      {licenseProofs.map((fileUrl, index) => {
        const isPDF =
          fileUrl.toLowerCase().endsWith(".pdf") ||
          fileUrl.includes("application/pdf");

        return (
          <div key={index} style={{ marginBottom: "5px" }}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDownload(fileUrl, index);
              }}
              style={{
                background: "none",
                border: "none",
                color: "#1976d2",
                textDecoration: "underline",
                cursor: "pointer",
                padding: 0,
                font: "inherit",
              }}
            >
              {isPDF
                ? `Download PDF ${index + 1}`
                : `Download License ${index + 1}`}
            </button>
          </div>
        );
      })}
    </div>
  );
};

//Just View License
// export const LicenseProofCellWithPreview = ({ values = [] }) => {
//   const [isScrollEnabled, setScrollEnabled] = useState(false);
//   const containerRef = useRef(null);

//   const licenseProofs = Array.isArray(values)
//     ? values.filter((file) => file)
//     : values
//     ? [values]
//     : [];

//   const handleClick = () => {
//     if (licenseProofs.length > 1 && !isScrollEnabled) {
//       setScrollEnabled(true);
//     }
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         containerRef.current &&
//         !containerRef.current.contains(event.target)
//       ) {
//         setScrollEnabled(false);
//       }
//     };

//     if (isScrollEnabled) {
//       document.addEventListener("click", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [isScrollEnabled]);

//   const handleDownload = (fileUrl, index) => {
//     const isPDF =
//       fileUrl.toLowerCase().endsWith(".pdf") ||
//       fileUrl.includes("application/pdf");
//     const isBase64 = fileUrl.startsWith("data:");

//     if (isBase64) {
//       const link = document.createElement("a");
//       link.href = fileUrl;
//       link.download = isPDF
//         ? `License_Proof_${index + 1}.pdf`
//         : `License_Proof_${index + 1}.jpg`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } else {
//       fetch(fileUrl)
//         .then((response) => response.blob())
//         .then((blob) => {
//           const url = window.URL.createObjectURL(blob);
//           const link = document.createElement("a");
//           link.href = url;
//           link.download = isPDF
//             ? `License_Proof_${index + 1}.pdf`
//             : `License_Proof_${index + 1}.jpg`;
//           document.body.appendChild(link);
//           link.click();
//           document.body.removeChild(link);
//           window.URL.revokeObjectURL(url);
//         })
//         .catch((error) => {
//           console.error("Download failed:", error);
//           window.open(fileUrl, "_blank");
//         });
//     }
//   };

//   const handlePreview = (fileUrl) => {
//     window.open(fileUrl, "_blank");
//   };

//   return (
//     <div
//       ref={containerRef}
//       style={getListMultiProofScrollStyles(isScrollEnabled, licenseProofs)}
//       onClick={handleClick}
//     >
//       {licenseProofs.map((fileUrl, index) => {
//         const isPDF =
//           fileUrl.toLowerCase().endsWith(".pdf") ||
//           fileUrl.includes("application/pdf");

//         return (
//           <div
//             key={index}
//             style={{ marginBottom: "5px", display: "flex", gap: "10px" }}
//           >
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleDownload(fileUrl, index);
//               }}
//               style={{
//                 background: "none",
//                 border: "none",
//                 color: "#1976d2",
//                 textDecoration: "underline",
//                 cursor: "pointer",
//                 padding: 0,
//                 font: "inherit",
//               }}
//             >
//               {isPDF
//                 ? `Download PDF ${index + 1}`
//                 : `Download License ${index + 1}`}
//             </button>
//             <span style={{ color: "#666" }}>|</span>
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handlePreview(fileUrl);
//               }}
//               style={{
//                 background: "none",
//                 border: "none",
//                 color: "#1976d2",
//                 textDecoration: "underline",
//                 cursor: "pointer",
//                 padding: 0,
//                 font: "inherit",
//               }}
//             >
//               Preview
//             </button>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

export const BarImageCell = ({ images = [] }) => {
  const [isScrollEnabled, setScrollEnabled] = useState(false);
  const containerRef = useRef(null);

  const imageUrls = Array.isArray(images)
    ? images.filter((img) => img)
    : images
    ? [images]
    : [];

  const shouldScroll = imageUrls.length > 2;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setScrollEnabled(false);
      }
    };

    if (isScrollEnabled) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isScrollEnabled]);

  return imageUrls.length > 0 ? (
    shouldScroll ? (
      <Scrollbars
        style={{ width: 200, height: 90 }}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        renderThumbHorizontal={(props) => (
          <div {...props} style={styles.listMultiImageScroll} />
        )}
      >
        <div style={styles.listImage}>
          {imageUrls.map((url, index) => (
            <img
              key={index}
              src={url}
              alt={`Bar Image ${index + 1}`}
              style={styles.listMultiImage}
            />
          ))}
        </div>
      </Scrollbars>
    ) : (
      <div style={styles.listImage}>
        {imageUrls.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`Bar Image ${index + 1}`}
            style={styles.listMultiImage}
          />
        ))}
      </div>
    )
  ) : (
    "No Images Available"
  );
};

export const WholesalerImageCell = ({ imageUrl, altText }) => {
  const defaultImage = "https://via.placeholder.com/150";
  const validImageUrl =
    imageUrl && imageUrl !== defaultImage ? imageUrl : defaultImage;

  return (
    <div style={styles.listImage}>
      <img
        src={validImageUrl}
        alt={altText || "Profile Image"}
        style={styles.listSingleImage}
        onError={(e) => {
          if (e.target.src !== defaultImage) {
            e.target.src = defaultImage;
            e.target.alt = "No Image Available";
          }
        }}
      />
    </div>
  );
};
